module.exports = __webpack_public_path__ + "img/logo.c39a7e2.png";